<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <div class="searchStyle">
                <el-button type="primary" size="medium" plain @click="back">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextStep">下一步</el-button>
              </div>
            </el-row>
            <div style="margin-right: 10px;font-size:16px;color:red;">
              <!-- <el-link type="danger" href="http://www.sales1.top/score/help/score_import.mp4" target="_blank">点我观看操作视频</el-link> -->
            </div>
            <div>
<!--              <el-link type="danger" href="javascript:window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')"
                target="_blank">点我寻求客服QQ远程支持</el-link> -->
            </div>
          </div>
        </div>
        <div class="rowTipStyle" style="text-align: center;">
          <div  style="font-size: 18px;font-weight: bold;">导入学生花名册</div>
          <div style="color: red;font-size: 16px;">重要:姓名,学号是手机端查询的条件,必须选择;不是"姓名","学号"的请选择"不导本列"</div>

        </div>
        <div style="padding: 10px;">

          <div width="100%">

            <el-table ref="dataList" :data="tableData" height="500" style="width: 100%" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <el-table-column label="设置各列数据对应关系" header-align="center" align="center">
                <el-table-column header-align="center" align="center" :key="col.prop" :label="col.label" :prop="col.prop"
                  v-for="(col,k) in cols">
                  <template slot="header" slot-scope="scope">
                    <div class="columnTitleStyle">
                      <div>{{col.label}}</div>
                      <div>
                        <el-tooltip class="item" effect="dark" content="不是'姓名','学号'的请选择'不导本列'" placement="top">
                          <el-select v-model="newColumnNames[k]" ref="columnSetting" placeholder="请选择" @change="selectChanged(k)">
                            <el-option v-for="item in columNames" :key="item.course_name" :label="item.course_name"
                              :value="item.course_name">
                            </el-option>
                          </el-select>
                        </el-tooltip>
                      </div>
                      <div v-if="paperScores[k]>0" class="paperShowStyle">
                        <div>卷面分</div>
                        <div style="text-decoration: underline;" @click="editPaperScore(k)">{{paperScores[k]}}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>

        </div>

      </el-col>
    </el-row>

    <!-- Form -->
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="清洗数据" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <div>
          <div class="settingRowStyle">
            <div><span style="color: red;">点击右侧的"+"或者"-"号,可删除无效的学生数据行</span></div>
            <div class="rowContentStyle">
              <el-input-number v-model="recordNum" :min="0" label="" @change="viewRecord"></el-input-number>
            </div>
          </div>
          <div class="settingRowStyle">
            <div style="font-size: 16px;font-weight: bold;">以下是即将导入的学生数据</div>
          </div>
          <div>
            <el-table :data="previewTableData" height="200" style="width: 100%" :header-cell-style="{background:'#eef1f6',color:'#606266'}">
              <!--               <el-table-column type="index" fixed label="序号" width="80" :index="previewIndexMethod" style="background:'#eef1f6',color:'#606266'">
               </el-table-column> -->

              <el-table-column header-align="center" align="center" :key="col.realName" :label="col.labelName" :prop="col.realName"
                v-for="(col) in previewColumnLables">
              </el-table-column>
            </el-table>
          </div>

        </div>

      </el-form>
      <div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPreviewSetting">取 消</el-button>
        <el-button type="primary" @click="nextPage">下一步</el-button>
      </div>
    </el-dialog>

    <el-dialog width="30%" :close-on-click-modal="false" title="输入卷面分" :visible.sync="paperScoreDialogVisible">
      <!-- <el-form-item label="卷面分"> -->
      <div class="colStyle">
        <div class="rowStyle">
          <div style="padding-right: 10px;white-space:nowrap;">{{convertCourseName(newColumnNames[currentColumn])}}卷面分</div>
          <div>
            <el-input v-model="currentPaperScore" autocomplete="off" placeholder="数字,如150" autofocus></el-input>
          </div>
        </div>
      </div>

      <!-- </el-form-item> -->

      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelSetPaperScore">取 消</el-button>
        <el-button type="primary" @click="setPaperScore">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'
  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        cols: ['', '', '', ''],
        id: '',
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,

        record: '', // 预览整条记录
        studentName: '', // 预览姓名
        studentNum: '', // 预览学号

        name_index: 0,
        num_index: 0,
        recordNum: 0,
        columNames: [],
        selectedColumnNames: [],
        newColumnNames: [],
        realColumnNames: [], // 选中导入字段的实际名称
        paperScores: [],
        columnCount: 0,
        rowcount: 0,
        dialogFormVisible: false,
        form: {},
        resData: '',
        loadFromMemory: 'memory',

        paperScoreDialogVisible: false,
        currentPaperScore: 0,
        currentColumn: -1,

        // 预览表格的相关数据
        previewColumnLables: [],
        previewTableData: []

      }
    },
    created() {
      this.loadData()

      this.username = this.$session.get('USERNAME') // 获取session
    },
    methods: {

      indexMethod(index) {
        var tmpIndex = this.tableData.length - index
        return tmpIndex
      },
      previewIndexMethod(index) {
        var tmpIndex = index
        return tmpIndex
      },
      loadCourses() {
        var tmpObj = {
          'course_name': '不导本列'
        }

        this.columNames.push(tmpObj)

        tmpObj = {
          'course_name': '姓名'
        }
        this.columNames.push(tmpObj)

        tmpObj = {
          'course_name': '学号'
        }
        this.columNames.push(tmpObj)
      },
      nextStep() {
        console.log(this.newColumnNames)

        if (this.newColumnNames.length === 0) {
          this.$alert('请选择各个列的含义,不是"姓名","学号"的请选择"不导本列".')
          return
        }

        for (var i = 0; i < this.columnCount; i++) {
          if (this.isEmpty(this.newColumnNames[i])) {
            this.$alert('请选择"第' + (i + 1) + '列"代表的含义,不是"姓名","学号"的请选择"不导本列"')
            return
          }
        }

        // 校验姓名和学号
        var foundName = false
        for (var n = 0; n < this.columnCount; n++) {
          if (this.newColumnNames[n] === '姓名') {
            foundName = true
            break
          }
        }

        if (!foundName) {
          this.$alert('必须选择姓名列！')
          return
        }

        var foundNum = false
        for (var l = 0; l < this.columnCount; l++) {
          if (this.newColumnNames[l] === '学号') {
            foundNum = true
            break
          }
        }

        if (!foundNum) {
          this.$alert('必须选择学号列！')
          return
        }

        this.dialogFormVisible = true
        this.realColumnNames.length = 0

        // 设置标题与实际列名对应关系
        for (var j = 0; j < this.columnCount; j++) {
          if (this.newColumnNames[j] !== '不导本列') {
            var keyName = j
            this.realColumnNames.push(keyName)
          }
        }

        console.log(this.realColumnNames)
        this.previewColumnLables.length = 0
        this.previewTableData.length = 0
        this.loadPreviewData(0)
      },
      nextPage() {
        let tmpTableData = []

        for (var p = (this.recordNum); p < this.rowcount; p++) {
          tmpTableData.push(this.tableData[p])
        }

        var jsList = encodeURIComponent(JSON.stringify(tmpTableData))
        var colList = encodeURIComponent(JSON.stringify(this.newColumnNames))
        var paperScoreList = encodeURIComponent(JSON.stringify(this.paperScores))

        this.$router.push({
          name: 'student_excel_final_preview',
          params: {
            jsList: jsList,
            colList: colList,
            paperScoreList: paperScoreList
          }
        })
      },
      changeStatus(val, index) {
        console.log(val + index)
      },
      preStep() {
        if (this.active > 0) {
          this.active = this.active - 1
        }
      },
      back() {
        this.$router.back()
      },
      convertCourseName(selectColumnName) {
        if (this.isEmpty(selectColumnName)) {
          return selectColumnName
        }
        var tmpStr = selectColumnName.replace(/成绩/, '')
        return tmpStr
      },
      selectChanged(index) {
      },
      handerEditor(index, row) {
        console.log(index + '  ' + row)
      },
      viewRecord() {
        // var obj = this.tableData[this.recordNum - 1]

        var tmpStr = ''

        this.loadPreviewData(this.recordNum)

        this.record = tmpStr
      },
      viewStudentName() {
        var nameKey = '第' + (this.name_index - 1) + '列'
        let tmpObj = this.tableData[this.recordNum - 1]
        this.studentName = tmpObj[nameKey]
      },
      viewStudentNum() {
        var nameKey = '第' + (this.num_index - 1) + '列'
        let tmpObj = this.tableData[this.recordNum - 1]
        this.studentNum = tmpObj[nameKey]
      },
      loadData(loadFrom, tableData) {
        if (loadFrom === this.loadFromMemory) {
          // console.log('1')
          this.resData.datalist = tableData

          console.log(tableData)
        } else {
          // console.log('2')
          this.resData = JSON.parse(decodeURIComponent(this.$route.params.jsList))
          this.tableData = this.resData.datalist
        }

        this.cols = []
        for (var j = 0; j < this.resData.colums.length; j++) {
          var obj = {}
          obj.label = '第' + (j + 1) + '列'
          obj.prop = '第' + j + '列'
          this.cols.push(obj)
        }

        // var tmpObj = {
        //   'course_name': '不导本列'
        // }
        // this.columNames.push(tmpObj)

        // tmpObj = {
        //   'course_name': '姓名'
        // }
        // this.columNames.push(tmpObj)

        // tmpObj = {
        //   'course_name': '学号'
        // }
        // this.columNames.push(tmpObj)

        this.loadCourses()

        // that.courses = response.data

        this.columnCount = this.resData.columcount

        this.rowcount = this.resData.rowcount

        for (var i = 0; i < this.columnCount; i++) {
          this.selectedColumnNames.push('')
          // this.paperScores.push(150)
        }
      },
      setPaperScore() {
        if (this.currentPaperScore <= 0 || this.isEmpty(this.currentPaperScore)) {
          this.$message.error('请输入卷面分')
          return
        }

        this.paperScores[this.currentColumn] = this.currentPaperScore
        this.paperScoreDialogVisible = false
        this.currentPaperScore = 0

        this.$refs.dataList.doLayout()
      },
      showPaperScoreDialog(k) {
        this.currentColumn = k
        this.currentPaperScore = this.paperScores[k]
        this.paperScoreDialogVisible = true
        this.$refs.dataList.doLayout()
      },
      cacelSetPaperScore() {
        this.paperScoreDialogVisible = false
        if (this.newColumnNames[this.currentColumn].indexOf('成绩') >= 0) {
          if (this.paperScores[this.currentColumn] === 0 || this.isEmpty(this.paperScores[this.currentColumn])) {
            this.newColumnNames[this.currentColumn] = ''
          }
        }
      },
      loadPreviewData(recordNum) {
        this.previewColumnLables.length = 0
        this.previewTableData.length = 0

        console.log(this.previewColumnLables)
        console.log(this.previewTableData)

        this.previewTableData = this.copyData(recordNum)

        for (var i = 0; i < this.realColumnNames.length; i++) {
          var p = this.realColumnNames[i]

          var keyName = '第' + p + '列'

          var obj = {
            realName: keyName,
            labelName: this.newColumnNames[p]
          }

          this.previewColumnLables.push(obj)
        }
      },
      copyData(start) {
        let tmpArray = []
        tmpArray.length = 0

        for (var i = start; i < this.tableData.length; i++) {
          tmpArray.push(this.tableData[i])
        }
        return tmpArray
      },
      cancelPreviewSetting() {
        this.previewColumnLables.length = 0
        this.dialogFormVisible = false
        this.previewTableData.length = 0
      },
      isValidScoreRow(row, colums) {
        var isValid = true
        var hasName = false
        var hasNum = false

        for (var i = 0; i < colums.length; i++) {
          var keyName = '第' + i + '列'

          var v = row[keyName]
          if (colums[i] !== '姓名') {
            if (v !== '') {
              hasName = true
            }
          }

          if (colums[i] !== '学号') {
            if (v !== '') {
              hasNum = true
            }
          }
        }

        isValid = hasName && hasNum

        return isValid
      },
      editPaperScore(k) {
        // console.log(k)
        this.showPaperScoreDialog(k)
      }

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rowTipStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .settingRowStyle {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid aliceblue;
    margin: 5px;
  }

  .rowContentStyle {
    display: flex;
    align-items: flex-start;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
  }

  .settingFormStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .titleBarStyle {
    display: flex;
  }

  .columnTitleStyle {
    display: flex;
    flex-direction: column;
  }

  .colStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .paperShowStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/student_excel_preview.vue